var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "span",
        {
          attrs: {
            title:
              "如果你之前填写过同一个表单, 点我可以加载上次填写的数据, 会覆盖(先清空)你现在已填写的数据"
          },
          on: { click: _vm.showDialog }
        },
        [_vm._v("加载表单数据")]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            top: "7vh",
            title: "加载表单数据",
            modal: false,
            visible: _vm.dialogVisible,
            width: "65%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { staticStyle: { "margin-left": "10px" }, attrs: { inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "搜索工单" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "240px" },
                    attrs: { placeholder: "输入工单编号或标题或内容搜索" },
                    model: {
                      value: _vm.searchKey,
                      callback: function($$v) {
                        _vm.searchKey = $$v
                      },
                      expression: "searchKey"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "80px" },
                      attrs: { title: "查询符合条件的工单[19]" },
                      on: { click: _vm.doSearch }
                    },
                    [_vm._v("搜索")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { "padding-left": "10px", "margin-bottom": "30px" },
              attrs: { data: _vm.ticketList }
            },
            [
              _c("div", { attrs: { slot: "empty" }, slot: "empty" }, [
                _c("div", { staticStyle: { height: "30px" } }, [
                  _vm._v("在上方的框中输入工单编号或标题，点击 "),
                  _c("b", [_vm._v("搜索")])
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("这里会列出你曾使用过的选项")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("向 "),
                  _c("a", { attrs: { target: "_blank", href: "/ticket/h" } }, [
                    _vm._v("管理员")
                  ]),
                  _vm._v(" 寻求帮助")
                ])
              ]),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "orderId", label: "编号", width: "180px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "标题", "min-width": "250px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("TicketTitle", {
                          attrs: {
                            ticketTitle: scope.row.orderTitle,
                            ticketNo: scope.row.orderId
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "creatorUser.name", label: "创建人" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "createdAt", label: "创建时间" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.doSelect(scope.row)
                              }
                            }
                          },
                          [_vm._v("选择")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ce07a77", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ce07a77","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/LoadFormData.vue
// module id = 780
// module chunks = 75